import { useBreakpoints } from '@hooks/useBreakpoints';
import type { MainMenuItem } from '@layout/MainMenu/MainMenu';
import { DeliveryLocationBanner } from '@layout/DeliveryLocationBanner/DeliveryLocationBanner';
import { LeadInBanner } from '@layout/LeadInBanner/LeadInBanner';
import type { DeliveryLocationBannerContent } from '@libs/deliverylocation-banner.helper';
import type { ContactAreaType } from '@models/api/contact-area-type.types';
import type { LeadIn } from '@models/api/page-content.types';
import type { LanguageAlternate } from '@models/data';
import type { ProductFragmentEnhanced } from '@models/enhanced-fragments';
import { Header } from './Header';
import { MainMenu } from '@layout/MainMenu/MainMenu';

export type HeaderProps = {
  deliveryLocationBannerContent: DeliveryLocationBannerContent | null;
  leadIn: LeadIn | null;
  mainMenuItems: MainMenuItem[];
  contactAreaType: ContactAreaType | null;
  languageAlternates: ReadonlyArray<LanguageAlternate>;
  currentProduct?: ProductFragmentEnhanced;
};

export const LegacyHeader = ({
  deliveryLocationBannerContent,
  leadIn,
  mainMenuItems,
  contactAreaType,
  languageAlternates,
  currentProduct,
}: HeaderProps) => {
  const { lg, available } = useBreakpoints();

  return (
    <>
      {deliveryLocationBannerContent && (
        <DeliveryLocationBanner
          title={deliveryLocationBannerContent.title}
          text={deliveryLocationBannerContent.text}
          allLocalesLabel={deliveryLocationBannerContent.allLocalesLabel}
          gotoLabel={deliveryLocationBannerContent.gotoLabel}
          currentProduct={currentProduct}
          languageAlternates={languageAlternates}
        />
      )}
      {(lg || !available) && leadIn && <LeadInBanner leadInJson={leadIn} />}
      <Header />
      <MainMenu
        languageAlternates={languageAlternates}
        contactAreaType={contactAreaType}
        mainMenuItems={mainMenuItems}
        currentProduct={currentProduct}
      />
    </>
  );
};
